export const mergeRecords = (entries) => entries.reduce((acc, _) => Object.assign(acc, _), {});
